import createApp from './main';

const { app, store, router } = createApp();

/* eslint-disable */
if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
}
/* eslint-enable */

router.onReady(() => {
  app.$mount('#app');
});
